// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3fOs9","info":"UpdateTermsInfo_info__2a85b"};